import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const id = props.show;

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const {
    control,
    register,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: {
      languages: [],
    },
  });
  const { fields } = useFieldArray({
    control,
    name: "languages",
  });
  const [countLang, setCountLang] = useState([]);
  const getLanguges = async () => {
    const response = await getData("/without-login/masters/all-languages");
    setCountLang(response.data);

    reset({
      languages: response.data.map((lang) => ({
        language_id: lang.id,
        question: "",
        answer: "",
      })),
    });
  };

  useEffect(() => {
    getLanguges();
  }, []);
  const onSubmit = async (data) => {
    try {
      // console.log(data);

      const sendData = new FormData();
      sendData.append("answer", data.languages[0]?.answer);
      sendData.append("question", data.languages[0]?.question);
      sendData.append("languages", JSON.stringify(data.languages));

      const response = await postData(`/masters/faq-category/${id}`, sendData);
      // console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/faq-category/${id}`);
    // setFormData(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Edit FAQ</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit FAQ</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                        <Row>
                          {fields.map((field, index) => (
                            <React.Fragment key={field.id}>
                              {/* Question */}
                              <Col md={12}>
                                <Form.Label column sm={3}>
                                  Name ({countLang[index]?.name})
                                </Form.Label>
                                <Col sm={6}>
                                  <Form.Control
                                    type="text"
                                    placeholder={`Enter Name in ${countLang[index]?.name}`}
                                    {...register(`languages.${index}.name`, {
                                      required: `Question is required in ${countLang[index]?.name}`,
                                    })}
                                  />
                                  {errors.languages?.[index]?.name && (
                                    <span className="text-danger">
                                      {errors.languages[index].name.message}
                                    </span>
                                  )}
                                </Col>
                              </Col>
                            </React.Fragment>
                          ))}

                          <Row className="mt-5 pb-3">
                            <div className="d-flex justify-content-center">
                              <Link>
                                <CancelButton
                                  name={"cancel"}
                                  handleClose={props.handleClose}
                                />
                              </Link>
                              <SaveButton
                                name={"save"}
                                handleSubmit={handleSubmit(onSubmit)}
                              />
                            </div>
                          </Row>
                        </Row>
                      </Form>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
